import { Component, ElementRef, Input, OnInit, ViewChild } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { Router } from "@angular/router";
import { DateTimeAdapter } from "@danielmoncada/angular-datetime-picker";
import { LoadingController } from "@ionic/angular";
import { TranslateService } from "@ngx-translate/core";
import { DictionaryService } from "src/app/dictionary";
import { PaginationClientSideOptions } from "src/app/app/_component/pagination-client-side/pagination-client-side-options";
import { PaginationColumn } from "src/app/app/_component/pagination-client-side/pagination-column.class";
import {
  SpaceDateFilterModel,
  SpaceDateFilterOptions,
} from "src/app/app/_component/_space/space-date-filter/space-date-filter.model";
import { SpaceDateFilterService } from "src/app/app/_component/_space/space-date-filter/space-date-filter.service";
import { BookingModel, BookingOwner, BookingSpace, BookingType } from "src/app/_models/booking.model";
import { GetSpacesModel } from "src/app/_models/space-requests.model";
import { SpaceModel } from "src/app/_models/space.model";
import { BookingService } from "src/app/_services/booking.service";
import { ErrorService } from "src/app/_services/error.service";
import { ThisPlatform } from "src/app/_services/platform.service";
import { RowsLoaderService } from "src/app/_services/rows-loader.service";
import { SpaceService } from "src/app/_services/space.service";
import { UserService } from "src/app/_services/user.service";
import { SpaceType } from "src/app/_types/space-type";
import { SpaceViewComponent } from "../space-view/space-view.component";
import { Observable, Subject, Subscription } from "rxjs";
import { addHours } from "date-fns";
import { BookingError } from "src/app/_models/booking.error.enum";
import { SelectButton } from "../../select-buttons/select-buttons.model";
import { MapWorkingMode } from "../space-map/space-map.model";
import { SpaceFilter } from "../space-filter/space-filter.model";
import { SpaceFilterService } from "../space-filter/space-filter.service";

@Component({
  selector: "app-space-add-reservation",
  templateUrl: "./space-add-reservation.component.html",
  styleUrls: ["./space-add-reservation.component.scss"],
})
export class SpaceAddReservationComponent implements OnInit {
  constructor(
    public spaceService: SpaceService,
    private translate: TranslateService,
    public bookingServ: BookingService,
    public userService: UserService,
    public p: ThisPlatform,
    private router: Router,
    private loadingCtrl: LoadingController,
    private dateTimeAdapter: DateTimeAdapter<any>,
    public dictionaryServ: DictionaryService,
    public spaceDateFilterService: SpaceDateFilterService,
    private spaceFilterService: SpaceFilterService,
    public errorService: ErrorService
  ) {}

  @Input()
  spaceType: SpaceType;

  workingMode: typeof MapWorkingMode = MapWorkingMode;

  @Input() events: Observable<void>;

  private eventsSubscription: Subscription;

  componentRef: any = SpaceViewComponent;
  rowsLoader: RowsLoaderService;
  dateFrom: any = new Date();
  dateTo: any = addHours(new Date(), 1); //new Date(new Date().setHours(new Date().getHours() + 1));
  showLoader: boolean;
  form: FormGroup;
  filterType: string = "me";
  carPlate: string;
  firstNameLastName: string;
  reservationTypesSlidedDown: boolean = true;
  startDate: any;
  endDate: any;
  subtype: number;
  navigateBackUrl: string;
  navigateBackQuery: string;
  showSpaceMap: boolean = false;
  noResultText: string = this.translate.instant("NO_RESULT");
  spacesReset: boolean = false;
  showFilterButtons: boolean = true;

  filterDetails: SpaceDateFilterModel = new SpaceDateFilterModel();

  options: PaginationClientSideOptions = {
    ...new PaginationClientSideOptions(),
    actionButton: "book-place",
    styleClasses: ["parking-space-list__mobile-container", "content-table"],
    overrideCountTranslation: "SPACE_",
    noResultsText: this.translate.instant("SPACE.FILTER_DATE"),
    customData: "add-parking-reservation",
    withAssignment: false,
  };

  spaceDateFilterOptions: SpaceDateFilterOptions;

  eventsSubject: Subject<void> = new Subject<void>();

  spacesLoadedSubject: Subject<SpaceModel[]> = new Subject<SpaceModel[]>();
  spacesResetSubject: Subject<void> = new Subject<void>();
  resetButtonsSubject: Subject<void> = new Subject<void>();

  columnsDefinitionSpace: PaginationColumn[] = [
    {
      name: "picture",
      displayName: "SPACE.VIEW",
      size: 2,
      sortable: false,
    },
    {
      name: "building",
      displayName: "SPACE.BUILDING",
      size: 2,
      sortable: true,
      colValue: (row) => {
        return row.floor.building.name;
      },
    },
    {
      name: "floor",
      displayName: "SPACE.LEVEL",
      size: 2,
      sortable: true,
      colValue: (row) => {
        return row.floor.name;
      },
    },
    {
      name: "name",
      displayName: "SPACE.PLACE",
      size: 6,
      sortable: true,
    },
  ];

  filterButtons: SelectButton[] = [
    {
      value: "list",
      key: this.translate.instant("LIST"),
      ionicIcon: "list",
    },
    {
      value: "map",
      key: this.translate.instant("MAP"),
      ionicIcon: "map",
    },
  ];

  @ViewChild("dateStart") dateStartCalendar: ElementRef;

  ngOnInit() {
    this.spaceService.spaces = [];
    this.options.spaceType = this.spaceType;
    this.eventsSubscription = this.events.subscribe(() =>
      this.parentIonViewWillLeave()
    );

    switch (this.spaceType) {
      case SpaceType.Parking:
        this.navigateBackUrl = "/app/parking";
        this.navigateBackQuery = "parking_my_reservations";
        this.showFilterButtons = true;
        this.spaceDateFilterOptions = {
          headerDesktop: "SPACE.FIND_FREE_SPACES",
          headerMobile: " ",
          searchButtonText: "SPACE.FILTER_DATE",
          spaceType: SpaceType.Parking,
          subtypeSource: "parkingSubtype",
        };
        this.noResultText = this.translate.instant("SPACE.PARKING.NO_RESULT");
        break;
      case SpaceType.Desk:
        this.navigateBackUrl = "/app/desk";
        this.navigateBackQuery = "desk_my_reservations";
        this.showFilterButtons = false;
        this.spaceDateFilterOptions = {
          headerDesktop: "SPACE.FIND_FREE_SPACES",
          headerMobile: " ",
          searchButtonText: "SPACE.FILTER_DATE",
          spaceType: SpaceType.Desk,
          subtypeSource: null,
        };
        break;
      case SpaceType.Room:
        this.navigateBackUrl = "/app/booking";
        this.navigateBackQuery = "events";
        this.showFilterButtons = false;
        this.spaceDateFilterOptions = {
          headerDesktop: "SPACE.FIND_FREE_SPACES",
          headerMobile: " ",
          searchButtonText: "BOOKING.SEARCH_SPACE",
          spaceType: SpaceType.Room,
          subtypeSource: null,
        };
        break;
    }
  }

  // UWAGA! W tym komponencie pierwszy request inicjowany jest w filtrze <app-space-date-filter>, dlatego tutaj nie ma ngOnInit

  loadSpaces(filterDetails: SpaceDateFilterModel) {
    this.filterDetails = filterDetails;
    this.showLoader = true;
    this.spaceDateFilterService.filtering = true;

    let requestParams: GetSpacesModel = {
      type: this.spaceType,
      free: true,
      dateFrom: filterDetails.startDate.toISOString(),
      dateTo: filterDetails.endDate.toISOString(),
      subType: filterDetails.subtype,
      buildings:
        filterDetails.buildings?.length > 0
          ? filterDetails.buildings.join(",")
          : null,
      floors:
        filterDetails.floors?.length > 0
          ? filterDetails.floors.join(",")
          : null,
      idUser: this.userService.userBasic?.id,
    };

    this.spaceService
      .getSpaces(requestParams)
      .subscribe((spaces: SpaceModel[]) => {
        this.spacesReset = false;
        this.showLoader = false;

        if (this.filterDetails.equipments?.length > 0) {
          this.spaceService.spaces = spaces.filter((space: SpaceModel) => {
            let equipmentsId = space.equipments.map((el) => el.id);
            return this.filterDetails.equipments.every((r) =>
              equipmentsId.includes(r)
            );
          });
        } else {
          this.spaceService.spaces = spaces;
        }

        this.rowsLoaderInit();
      });

    this.options.noResultsText = this.noResultText;
  }

  resetSpaces() {
    this.spaceService.spaces = [];
    this.spacesReset = true;
    this.options.noResultsText = this.translate.instant("SPACE.FILTER_DATE");
    this.rowsLoaderInit();
    this.spacesResetSubject.next();
  }

  onBookSpace(space) {
    let booking: BookingModel = new BookingModel();
    let bookingSpace = new BookingSpace();
    bookingSpace.idSpace = space.id;
    booking.owner = BookingOwner.Me;

    if (this.spaceDateFilterService.filterType == "me") {
      booking.owner = BookingOwner.Me;
    }

    if (this.spaceDateFilterService.filterType == "user") {
      booking.idUserOwner = this.userService.userBasic.id;
      booking.owner = BookingOwner.User;
    }

    if (this.spaceDateFilterService.filterType == "guest") {
      booking.description = this.spaceDateFilterService.firstNameLastName;
      booking.owner = BookingOwner.Guest;
    }

    if (this.spaceDateFilterService.additionalContent) {
      bookingSpace.number = this.spaceDateFilterService.additionalContent;
    } else {
      bookingSpace.number = " ";
    }

    booking.bookingSpaces.push(bookingSpace);

    if (this.spaceType === SpaceType.Room) {
      if (this.userService.user.id) {
        booking.title =
          this.userService.user.firstName +
          " " +
          this.userService.user.lastName;
      } else if (this.userService.userStorage.lastName) {
        booking.title =
          this.userService.userStorage.firstName +
          " " +
          this.userService.userStorage.lastName;
      } else {
        booking.title = this.userService.userStorage.firstName + " ";
      }

      if (this.spaceDateFilterService.additionalContent) {
        booking.title =
          booking.title + " " + this.spaceDateFilterService.additionalContent;
      }
    } else {
      booking.title = "empty";
    }

    booking.startTime = new Date(this.filterDetails.startDate);
    booking.endTime = new Date(this.filterDetails.endDate);

    switch (this.spaceType) {
      case SpaceType.Parking:
        booking.type = BookingType.Parking;
        break;
      case SpaceType.Desk:
        booking.type = BookingType.Desk;
        break;
      case SpaceType.Room:
        booking.type = BookingType.Room;
        break;
    }

    // booking.number = this.userService.user.carPlate;  TODO: czeka na dodanie pola "number" do obiektu booking

    this.bookingServ.booking = booking;

    this.loadingCtrl
      .create({
        keyboardClose: true,
        message: this.translate.instant("SAVING"),
      })
      .then((loadingEl) => {
        loadingEl.present();
        this.bookingServ.createBooking().subscribe({
          next: (res) => {
            this.parentIonViewWillLeave();
            loadingEl.dismiss();
            this.router.navigate([this.navigateBackUrl], {
              queryParams: { section: this.navigateBackQuery },
            });
          },
          error: (err) => {
            loadingEl.dismiss();
            const errorCode: BookingError = err.error.code;
            let bookingError: string;
            switch (errorCode) {
              case BookingError.INVALID_DATE:
                bookingError = "BOOKING.ERROR_INVALID_DATE";
                break;
              case BookingError.EXCEEDS_LIMIT:
                bookingError = "BOOKING.ERROR_EXCEEDS_LIMIT";
                break;
              case BookingError.ITEMS_MISSING:
                bookingError = "BOOKING.ERROR_ITEMS_MISSING";
                break;
              case BookingError.SPACE_BOOKED:
                bookingError = "BOOKING.ERROR_SPACE_BOOKED";
                break;
              case BookingError.CONFLICT:
                bookingError = "BOOKING.ERROR_CONFLICT";
                break;
            }
            this.errorService.showPopupAlert(bookingError);
            this.options.actionButtonDisabled = false;
          },
          complete: () => { 
            this.options.actionButtonDisabled = false;
          }
        });
      });
  }

  onChangeSpacesVisualisation(event) {
    if (event === "list") {
      this.showSpaceMap = false;
    } else if (event === "map") {
      this.showSpaceMap = true;
    }
    setTimeout(() => {
      this.rowsLoaderInit();
    }, 10);
  }

  rowsLoaderInit() {
    if (this.showSpaceMap) {
      this.spacesLoadedSubject.next(this.spaceService.spaces);
    } else {
      if (this.rowsLoader) {
        this.rowsLoader.init(this.spaceService.spaces);
      }
    }
    this.spaceDateFilterService.filtering = false;
  }

  rowsLoaderServiceReady(loader: RowsLoaderService) {
    this.rowsLoader = loader;
  }

  parentIonViewWillLeave() {
    this.spaceFilterService.filterDetails = new SpaceFilter();
    this.showSpaceMap = false;
    this.eventsSubject.next();
    this.resetButtonsSubject.next();
    setTimeout(() => {
      this.resetSpaces();
    }, 10);
  }

  ngOnDestroy() {
    this.spaceService.spaces = [];
    this.eventsSubscription?.unsubscribe();
  }
}
